import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

type ExpenseState = {
  isOpenAddingExpense: boolean;
  defaultExpenseCategory: string | null;
  setIsOpenAddingExpense: (isOpen: boolean) => void;
  setDefaultExpenseCategory: (category: string | null) => void;
};

const useExpenseStore = create<ExpenseState>()(
  devtools(
    persist(
      (set) => ({
        isOpenAddingExpense: false,
        setIsOpenAddingExpense: (isOpenAddingExpense) =>
          set(() => ({ isOpenAddingExpense })),
        setDefaultExpenseCategory: (defaultExpenseCategory) =>
          set(() => ({ defaultExpenseCategory })),
        defaultExpenseCategory: null,
      }),
      { name: 'expenseStore' }
    )
  )
);

export const useState = () =>
  useExpenseStore((state) => ({
    isOpenAddingExpense: state.isOpenAddingExpense,
  }));

export const useModelActions = () =>
  useExpenseStore((state) => ({
    setIsOpenAddingExpense: state.setIsOpenAddingExpense,
  }));

export default useExpenseStore;
